// Center `el` inside `container` by scrolling only that container.
// Element.scrollIntoView scrolls every scrollable ancestor (the page, the
// editor column), which is why seeking a transcript used to nudge the whole
// page; this touches one scroll position.
export function scrollWithin(container: HTMLElement | null, el: HTMLElement | null, behavior: ScrollBehavior = "smooth") {
  if (!container || !el) return;
  const c = container.getBoundingClientRect();
  const r = el.getBoundingClientRect();
  const top = container.scrollTop + (r.top - c.top) - container.clientHeight / 2 + el.clientHeight / 2;
  container.scrollTo({ top: Math.max(0, top), behavior });
}
